import React from 'react';
import { heroStats } from '../../data/content';
export function Stats() {
  return <section aria-label="Chiffres clés" className="w-full border-y border-navy/10 bg-white px-4 py-7" data-id="element-231" data-mp="2fggesn9g1knc">
      <div className="mx-auto grid max-w-3xl grid-cols-2 gap-y-6 gap-x-4 sm:grid-cols-4" data-id="element-232" data-mp="2aglpup98b54x">
        {heroStats.map(stat => <div key={stat.label} className="text-center" data-id="element-233" data-mp="26gjpqkj56jrr">
            <p className="font-display text-3xl font-black text-navy-deep sm:text-4xl" data-id="element-234" data-mp="335sqbts8u4st">
              {stat.value}
            </p>
            <p className="mx-auto mt-1 max-w-[150px] text-[10px] font-bold uppercase leading-tight tracking-wider text-ink/55 sm:text-[11px]" data-id="element-235" data-mp="2y7r4x27chte6">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}